import { Link } from "@tanstack/react-router";

export interface BlogCardPost {
  slug: string;
  title: string;
  category: string;
  published_at: string;
  description?: string;
  reading_minutes?: number;
}

export function BlogCard({ post, compact = false, hidden = false }: {
  post: BlogCardPost; compact?: boolean; hidden?: boolean;
}) {
  return (
    <Link
      to="/blog/$slug"
      params={{ slug: post.slug }}
      hidden={hidden}
      className="blog-card group block rounded-lg border p-6 transition-colors"
    >
      <div className="blog-card-meta mono uppercase">
        {post.category} · {new Date(post.published_at).toLocaleDateString("en-US", {
          timeZone: "America/Phoenix", month: "short", day: "numeric", year: "numeric",
        })}
      </div>
      {compact ? <h3 className="blog-card-title mt-3">{post.title}</h3> : <h2 className="blog-card-title mt-3">{post.title}</h2>}
      {!compact && <>
        <p className="blog-card-description mt-3">{post.description}</p>
        <div className="blog-card-read mono mt-4 uppercase">Read · {post.reading_minutes} min →</div>
      </>}
    </Link>
  );
}